import { z } from 'zod';
/** Intrinsic characteristics a service can declare for an Agentic Platform capability. */
export const AgenticPlatformCapabilityTagSchema = z.enum(['ResponseCouldIncludePhi']);
export const AgenticPlatformCapabilityMetadataSchema = z.strictObject({
    capabilityTags: z.array(AgenticPlatformCapabilityTagSchema),
});
//# sourceMappingURL=capabilityMetadata.js.map